import script from "./packageInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./packageInfo.vue?vue&type=script&setup=true&lang=ts"

import "./packageInfo.vue?vue&type=style&index=0&id=3c4bed90&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4bed90"]])

export default __exports__